import { ContractBinding } from 'views/TradingCompetitionV3/contract'
import { COMPETITIONS, CREATE, REFERRAL } from 'views/TradingCompetitionV3/routes'
import { V4_ADDRESS, V4_API_URL, V4_CHAIN_ID } from './config'

/** Same list/detail UI as V3, bound to the V4 contract and API. No referral page: the referral link lives on the create page. */
export const V4_BINDING: ContractBinding = {
  version: 4, address: V4_ADDRESS, chainId: V4_CHAIN_ID, apiUrl: V4_API_URL, base: COMPETITIONS,
  tabs: [
    { href: COMPETITIONS, label: 'Competitions' },
    { href: CREATE, label: 'Create' },
    { href: REFERRAL, label: 'Rewards & referral' },
  ],
}
